// eslint-disable-next-line import/prefer-default-export
export const WTAPI_CONNECTING = 'WTAPI_CONNECTING';
export const WTAPI_CONNECTED = 'WTAPI_CONNECTED';
export const WTAPI_DISCONNECTED = 'WTAPI_DISCONNECTED';
